export default __webpack_public_path__ + "static/media/down-grey.079fea34.svg";